import { useState, useEffect } from 'react';
import API from '../api';
import './Admin.css';

const Admin = () => {
  const [formData, setFormData] = useState({
    titulo: '',
    descripcion: '',
    imagen: '',
    linkTrailer: '',
    enEmision: true,
    categorias: [],
    episodios: []
  });

  const [episodioActual, setEpisodioActual] = useState({
    numero: '',
    tituloEpisodio: '',
    linkVideo: ''
  });

  const [allCategories, setAllCategories] = useState([]);
  const [animes, setAnimes] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [search, setSearch] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      try {
        const catRes = await API.get('/categories');
        const animeRes = await API.get('/animes');

        setAllCategories(catRes.data || []);
        setAnimes(animeRes.data || []);
      } catch (err) {
        console.error(err);
      }
    };

    fetchData();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value === 'true' ? true : value === 'false' ? false : value
    }));
  };

  const handleEdit = (anime) => {
    setFormData({
      titulo: anime.titulo || '',
      descripcion: anime.descripcion || '',
      imagen: anime.imagen || '',
      linkTrailer: anime.linkTrailer || '',
      enEmision: anime.enEmision ?? true,
      categorias: anime.categorias?.map(c => c._id || c) || [],
      episodios: anime.episodios || []
    });

    setEditingId(anime._id);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const agregarEpisodio = () => {
    if (!episodioActual.numero || !episodioActual.linkVideo) return;

    const nuevo = {
      ...episodioActual,
      numero: Number(episodioActual.numero)
    };

    setFormData(prev => ({
      ...prev,
      episodios: [...prev.episodios, nuevo]
    }));

    setEpisodioActual({ numero: '', tituloEpisodio: '', linkVideo: '' });
  };

  const eliminarEpisodio = (index) => {
    setFormData(prev => ({
      ...prev,
      episodios: prev.episodios.filter((_, i) => i !== index)
    }));
  };

  const handleDelete = async (id) => {
    if (!window.confirm("¿Estás seguro de que deseas eliminar este anime?")) return;
    try {
      await API.delete(`/animes/${id}`);
      setAnimes(prev => prev.filter(anime => anime._id !== id));
    } catch (err) {
      console.error("Error al eliminar anime", err);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      ...formData,
      episodios: formData.episodios.map(ep => ({
        ...(ep._id && { _id: ep._id }),
        ...(ep.fechaSubida && { fechaSubida: ep.fechaSubida }),
        
        numero: Number(ep.numero),
        tituloEpisodio: ep.tituloEpisodio,
        linkVideo: ep.linkVideo
      })),
      totalCapitulos: formData.episodios.length
    };

    try {
      if (editingId) {
        await API.put(`/animes/${editingId}`, payload);
      } else {
        await API.post('/animes', payload);
      }

      setFormData({
        titulo: '',
        descripcion: '',
        imagen: '',
        linkTrailer: '',
        enEmision: true,
        categorias: [],
        episodios: []
      });

      setEditingId(null);
      const res = await API.get('/animes');
      setAnimes(res.data || []);

    } catch (err) {
      console.error(err);
    }
  };

  const filteredAnimes = animes.filter(a =>
    a.titulo?.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="admin-container">
      <form onSubmit={handleSubmit} className="admin-form">
        <h2>Panel Admin</h2>

        <input
          name="titulo"
          placeholder="Título"
          value={formData.titulo}
          onChange={handleChange}
        />

        <textarea
          name="descripcion"
          placeholder="Descripción"
          value={formData.descripcion}
          onChange={handleChange}
        />

        <input
          name="imagen"
          placeholder="Imagen URL"
          value={formData.imagen}
          onChange={handleChange}
        />

        <input
          name="linkTrailer"
          placeholder="Trailer URL"
          value={formData.linkTrailer}
          onChange={handleChange}
        />

        {/* CONTENEDOR DEL SELECT DE EMISIÓN */}
        <div className="admin-select-group">
          <label>Estado del Anime:</label>
          <select
            name="enEmision"
            value={formData.enEmision}
            onChange={handleChange}
          >
            <option value="true">🟢 En Emisión</option>
            <option value="false">🔴 Finalizado</option>
          </select>
        </div>

        <h3>Categorías</h3>
        <div className="categories">
          {allCategories.map(cat => (
            <label key={cat._id} className="category-item">
              <input
                type="checkbox"
                checked={formData.categorias.includes(cat._id)}
                onChange={(e) => {
                  const checked = e.target.checked;
                  setFormData(prev => ({
                    ...prev,
                    categorias: checked
                      ? [...prev.categorias, cat._id]
                      : prev.categorias.filter(id => id !== cat._id)
                  }));
                }}
              />
              {cat.nombre}
            </label>
          ))}
        </div>

        <h3>Episodios</h3>
        <input
          type="number"
          placeholder="Número"
          value={episodioActual.numero}
          onChange={e =>
            setEpisodioActual({ ...episodioActual, numero: e.target.value })
          }
        />

        <input
          placeholder="Título episodio"
          value={episodioActual.tituloEpisodio}
          onChange={e =>
            setEpisodioActual({ ...episodioActual, tituloEpisodio: e.target.value })
          }
        />

        <input
          placeholder="Video URL"
          value={episodioActual.linkVideo}
          onChange={e =>
            setEpisodioActual({ ...episodioActual, linkVideo: e.target.value })
          }
        />

        <button type="button" className="btn-secondary" onClick={agregarEpisodio}>
          Agregar Episodio
        </button>

        <div className="episodes-list">
          {formData.episodios.map((ep, i) => (
            <div key={i} className="episode-item">
              <span>Ep {ep.numero} - {ep.tituloEpisodio}</span>
              <button type="button" onClick={() => eliminarEpisodio(i)}>✖</button>
            </div>
          ))}
        </div>

        <button type="submit" className="btn-primary">
          {editingId ? "Actualizar Anime" : "Crear Anime"}
        </button>
      </form>

      <div className="admin-list">
        <input
          className="search-input"
          placeholder="Buscar..."
          value={search}
          onChange={e => setSearch(e.target.value)}
        />

        {filteredAnimes.map(anime => (
          <div key={anime._id} className="admin-card">
            <img src={anime.imagen} alt={anime.titulo} />
            <div className="admin-card-info">
              <h4>{anime.titulo}</h4>
              <p className={`status-text ${anime.enEmision ? 'emision' : 'finalizado'}`}>
                {anime.enEmision ? "● En Emisión" : "● Finalizado"}
              </p>
              <div className="admin-card-actions">
                <button className="btn-edit" onClick={() => handleEdit(anime)} title="Editar">✏️</button>
                <button className="btn-delete" onClick={() => handleDelete(anime._id)} title="Eliminar">🗑</button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Admin;